module.exports = __webpack_public_path__ + "static/media/M73ws.190c07b5.pdf";